/* eslint-disable @typescript-eslint/explicit-module-boundary-types */
import React, { useState, useEffect } from 'react';
import { css } from 'styled-components';
import uniqueId from '../../../../helpers/uniqueId';
import Button from '@legacy-vfuk/core-button';

const externalLinkWrapperStyles = css`
  padding: 10px 0;
  width: fit-content;
  max-width: 100%;
`;

type ExternalLinkProps = {
  label: string;
  href: string;
};

const CtaExternalLink = ({ label, href }: ExternalLinkProps) => {
  const [pageTitle, setPageTitle] = useState('');

  useEffect(() => {
    setTimeout(() => {
      const elem = document.getElementsByTagName('TITLE')[0];
      setPageTitle(elem.innerHTML);
    }, 500);
  }, []);

  return (
    <div css={externalLinkWrapperStyles}>
      <Button
        id="ctaExternalLink"
        text={label}
        appearance="primary"
        href={href}
        htmlAttributes={{
          target: '_blank',
        }}
        dataAttributes={{
          'data-analytics-element': uniqueId(label),
          'data-analytics-category': 'cta-external-link',
          'data-analytics-context': pageTitle,
        }}
      />
    </div>
  );
};

export default CtaExternalLink;
